import { canalDeOperacoesDaTela, type RespostaDaTela } from './operacoesDaTela'

/** O retry do POST de confirmação reutiliza a resposta, nunca o setter. */
const respostas = new Map<string, { ate: number, promessa: Promise<RespostaDaTela> }>()

export async function processarOperacaoDaTela (
  pedido: Record<string, unknown>,
  escopo: string,
  ativo: () => boolean,
  autorizado: () => boolean,
  responder: (pedidoId: string, resposta: RespostaDaTela) => Promise<void>
): Promise<void> {
  if (typeof pedido.pedido_id !== 'string' || typeof pedido.expira_em !== 'number' || !ativo() || pedido.expira_em <= Date.now()) return
  for (const [chave, item] of respostas) if (item.ate < Date.now()) respostas.delete(chave)
  const chave = `${escopo}:${pedido.pedido_id}`
  let item = respostas.get(chave)
  if (!item) {
    if (respostas.size >= 100) return
    const ate = Math.min(pedido.expira_em, Date.now() + 20000)
    const executar = async (): Promise<RespostaDaTela> => {
      do {
        if (!ativo()) return { status: 'recusado', codigo: 'contexto_alterado', salvo: false }
        if (!autorizado()) return { status: 'recusado', codigo: 'leitura_da_tela_nao_autorizada', salvo: false }
        try {
          const resultado = canalDeOperacoesDaTela.executar(pedido, escopo)
          if (resultado.codigo !== 'tela_indisponivel' || pedido.operacao !== 'ler') return resultado
        } catch {
          return { status: 'recusado', codigo: 'falha_na_tela', salvo: false }
        }
        await new Promise(resolve => setTimeout(resolve, 100))
      } while (Date.now() < ate - 500)
      return { status: 'recusado', codigo: 'tela_indisponivel', salvo: false }
    }
    item = { ate: ate + 60000, promessa: executar() }
    respostas.set(chave, item)
  }
  const resposta = await item.promessa
  if (ativo() && autorizado()) await responder(pedido.pedido_id, resposta)
  else if (ativo()) await responder(pedido.pedido_id, { status: 'recusado', codigo: 'leitura_da_tela_nao_autorizada', salvo: false })
}
